/**
 * Detect Better Auth "email not verified" failures.
 * Password is already validated before this error is thrown, so it is safe
 * to advance to the OTP step only when this matches.
 */

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null;
}

function authErrorCode(error: unknown): string {
  return isRecord(error) && typeof error.code === 'string'
    ? error.code.toLowerCase()
    : '';
}

function authErrorMessage(error: unknown): string {
  if (error instanceof Error) return error.message.toLowerCase();
  return isRecord(error) && typeof error.message === 'string'
    ? error.message.toLowerCase()
    : '';
}

export function isEmailNotVerifiedAuthError(error: unknown): boolean {
  if (!isRecord(error)) {
    return false;
  }

  if (error.code === 'EMAIL_NOT_VERIFIED') {
    return true;
  }

  if (
    typeof error.message === 'string' &&
    error.message.toLowerCase().includes('email not verified')
  ) {
    return true;
  }

  return false;
}

export function isInvalidCredentialAuthError(error: unknown): boolean {
  const code = authErrorCode(error);
  if (code === 'invalid_email_or_password' || code === 'invalid_password') {
    return true;
  }
  const message = authErrorMessage(error);
  return (
    message.includes('invalid email or password') ||
    message.includes('invalid password') ||
    message.includes('invalid_password') ||
    message.includes('invalidsecret')
  );
}
